module.exports = __webpack_public_path__ + "static/media/leaderboard.90fd741f.png";